// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconCollapseArrows.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconCollapseArrows = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 12 12" fill="currentColor" { ...props }>
    <path d="M6 3.42857L1.5 0L10.5 7.15256e-07L6 3.42857Z" />
    <path d="M6 8.57143L10.5 12L1.5 12L6 8.57143Z" />
  </BaseIcon>
);

export default IconCollapseArrows;
